import { IState } from "@customTypes/ItemTypes";
import { getEntitlementsAgainstDuns } from "@factories/companyInfo";
import { ALL_API_ENHANCEMENT } from "@helpers/constants";
import { removeDuplicates } from "@helpers/duplicateRemover";
import { setIsLoading } from "@redux/actions";
import { setEntitlements } from "@redux/actions/entilementsActions";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

const useEntitlementsForADuns = (activeDuns: string) => {
    const dispatch = useDispatch();
    const entitlements = useSelector((state: IState) => state.entitlements);
    const [error, setError] = useState<string | null>(null);
    const hasloaded = useSelector((state: IState) => state.isFullPageLoading);

    useEffect(() => {
        if (ALL_API_ENHANCEMENT) {
            if (!activeDuns) return dispatch(setIsLoading(false));
            if (!hasloaded) return dispatch(setIsLoading(false));

            const fetchEntitlements = async () => {
                try {
                    const res = await getEntitlementsAgainstDuns(activeDuns);
                    dispatch(setIsLoading(false));

                    const newEntitlements = {
                        companyInfo: removeDuplicates([...(res?.companyInfo || []), ...(entitlements.companyInfo || [])]),
                        vboEntitlements: removeDuplicates([...(res?.vboEntitlements || []), ...(entitlements.vboEntitlements || [])]),
                        vboAssociatedDuns: removeDuplicates([...(res?.vboAssociatedDuns || []), ...(entitlements.vboAssociatedDuns || [])]),
                        credibilityEntitlements: removeDuplicates([...(res?.credibilityEntitlements || []), ...(entitlements.credibilityEntitlements || [])]),
                        vboAssociatedDunsWithProduct: removeDuplicates([...(res?.vboAssociatedDunsWithProduct || []), ...(entitlements.vboAssociatedDunsWithProduct || [])])
                    };

                    dispatch(setEntitlements(newEntitlements));
                } catch (e) {
                    console.error("Error fetching getEntitlementsAgainstDuns", e);
                    setError("Failed to fetch entitlements.");
                    dispatch(setIsLoading(false));

                }
            };

            fetchEntitlements();
        } else {
            dispatch(setIsLoading(false));

        }
    }, [activeDuns, hasloaded]);

    return { error };
};

export default useEntitlementsForADuns;
